"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cidrToMask(subnet) {
    var split = subnet.split('/');
    return parseInt(split[1], 10);
}
exports.cidrToMask = cidrToMask;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2lkclRvTWFzay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkNpZHJUb01hc2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvQkFBNEIsTUFBYztJQUN4QyxJQUFJLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQzdCLE1BQU0sQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0FBQy9CLENBQUM7QUFIRCxnQ0FHQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/CidrToMask.ts
// module id = 7
// module chunks = 0